import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { I18nextProvider } from "react-i18next";
import { Provider } from "react-redux";
import "swiper/css";
import App from "./components/App";
import "./index.css";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

import common_ar from "./translations/common_ar.json";
import common_en from "./translations/common_en.json";
import common_es from "./translations/common_es.json";
import common_fr from "./translations/common_fr.json";
import common_pt from "./translations/common_pt.json";
import common_ru from "./translations/common_ru.json";
import common_tr from "./translations/common_tr.json";
import common_zh from "./translations/common_zh.json";

import SnackbarProvider from "./components/SnackBar";

import store from "./redux/store";

// import { setAssetPath } from "@esri/calcite-components/dist/components"
// setAssetPath("https://js.arcgis.com/calcite-components/2.4.0/assets");

import "@esri/calcite-components/dist/calcite/calcite.css";

import { defineCustomElements } from "@esri/calcite-components/dist/loader";
import { createRoot } from "react-dom/client";
import AppAuthProvider from "./components/AppAuthProvider";
import AppConfigProvider from "./components/AppConfigProvider";
import { APP_ENV } from "./data/constants";

// CDN hosted assets
defineCustomElements(window, {
  resourcesUrl:
    "https://cdn.jsdelivr.net/npm/@esri/calcite-components/dist/calcite/assets",
});

if (process.env.NODE_ENV === "production") {
  const script = document.createElement("script");
  script.async = true;
  script.src = "https://www.googletagmanager.com/gtag/js?id=G-GHEYC5MXFS";
  document.head.appendChild(script);

  const configScript = document.createElement("script");
  configScript.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'G-GHEYC5MXFS');
  `;
  document.head.appendChild(configScript);
}

i18next.use(LanguageDetector);
i18next
  .init({
    interpolation: { escapeValue: false }, // React already does escaping
    resources: {
      ar: { common: common_ar },
      zh: { common: common_zh },
      en: { common: common_en },
      es: { common: common_es },
      fr: { common: common_fr },
      ru: { common: common_ru },
      pt: { common: common_pt },
      tr: { common: common_tr },
    },
    fallbackLng: "en",
    supportedLngs: ["ar", "zh", "en", "es", "fr", "ru", "pt", "tr"],
    detection: {
      lookupQuerystring: "lang",
    },
  })
  .then(() => {
    const container = document.getElementById("root");
    const root = createRoot(container);

    root.render(
      <Provider store={store}>
        <SnackbarProvider>
          <I18nextProvider i18n={i18next}>
            <AppConfigProvider>
              <AppAuthProvider>
                <App />
              </AppAuthProvider>
            </AppConfigProvider>
          </I18nextProvider>
        </SnackbarProvider>
      </Provider>
    );
  });

console.log(
  `App running in APP_ENV: ${APP_ENV}, NODE_ENV: ${process.env.NODE_ENV} mode`
);

const configuration = {
  onUpdate: (registration) => {
    //New version available. Update the application (only next time the url is opened)
    //...we might give feedback also to the user
    const event = new Event("swUpdatefound");
    window.dispatchEvent(event);
    if (registration && registration.waiting)
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
  },
};

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorkerRegistration.unregister(configuration);
